import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { DiaperCarouselCSS } from './DiaperCarousel.styled';

export default function CarouselSection(props) {
  let { mainProductImages, selectedCard } = props;
  mainProductImages = mainProductImages.filter(
    (data) => !data.includes('youtube.com'),
  );

  const carousel = useRef(null);
  useEffect(() => {
    if (carousel.current && carousel.current?.state?.selectedItem > 0) {
      carousel.current.state.selectedItem = 0;
    }
  }, [selectedCard]);

  return (
    <DiaperCarouselCSS>
      <Carousel
        key={selectedCard}
        ref={carousel}
        showIndicators={true}
        showThumbs={false}
        emulateTouch
        showArrows={true}
        showStatus={false}
        autoPlay={false}
      >
        {mainProductImages?.map((element, index) => {
          return (
            <div key={`carousel_${index}`}>
              <Image
                src={element}
                alt="carouselpopup"
                quality={90}
                fill
                sizes="80vw"
              />
            </div>
          );
        })}
      </Carousel>
    </DiaperCarouselCSS>
  );
}
